<div class="outer-div">

  <!-- Header -->
  <div class="label-bar">
    <label class="kc-title">Key changes</label>
    <span class="example-spacer"></span>
    <app-common-button
      title="Refresh"
      icon="fas fa-sync-alt"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onRefresh()"
      style="margin-left: 6px; margin-right: 6px">
    </app-common-button>

    <app-common-button
      icon="fas fa-download"
      title="Download"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onDownload()"
      style="margin-left: 6px; margin-right: 6px">
    </app-common-button>
  </div>

  <!-- Main Card -->
  <div class="kc-card">

    <!-- Filters -->
    <div class="kc-filter-section">

      <!-- From Date -->
      <mat-form-field appearance="outline">
        <mat-label>From Date</mat-label>
        <input matInput [matDatepicker]="fromPicker" [(ngModel)]="fromDate">
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <!-- To Date -->
      <mat-form-field appearance="outline">
        <mat-label>To Date</mat-label>
        <input matInput [matDatepicker]="toPicker" [(ngModel)]="toDate">
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>

      <!-- Run Button -->
      <div class="kc-run-btn">
        <app-common-button 
          label="Run"
          title="Run"
          [buttonId]="1111"
          width="96px"
          [critical]="true"
          (clicked)="onRun()">
        </app-common-button>
      </div>

    </div>

    <!-- Divider -->
    <div class="kc-divider"></div>

   <div class="kc-dropdown-section">

 <!-- Product -->
  <p-select
    [options]="productOptions"
    placeholder="Product"
    optionLabel="label"
    optionValue="value"
    [filter]="true"
    [showClear]="true"
     panelStyleClass="custom-pselect-panel"
         appendTo="body"
    class="filter-dd"
    [(ngModel)]="selectedProduct"
    (onChange)="applyFilters()">
  </p-select>

  <!-- Module -->
  <p-select
    [options]="moduleOptions"
    placeholder="Module"
    optionLabel="label"
    optionValue="value"
    [filter]="true"
    [showClear]="true"
     panelStyleClass="custom-pselect-panel"
         appendTo="body"
    class="filter-dd"
    [(ngModel)]="selectedModule"
    (onChange)="applyFilters()">
  </p-select>

  <!-- User -->
  <p-select
    [options]="userOptions"
    placeholder="User"
    optionLabel="label"
    optionValue="value"
    [filter]="true"
    [showClear]="true"
     panelStyleClass="custom-pselect-panel"
         appendTo="body"
    class="filter-dd"
    [(ngModel)]="selectedUser"
    (onChange)="applyFilters()">
  </p-select>

</div>


    <!-- Grid -->
    <div class="kc-grid-container">

      <ag-grid-angular
        class="ag-theme-balham kc-grid"
        [rowData]="keyChangesData"
        [defaultColDef]="defaultColDef"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [pagination]="true"
        [paginationPageSize]="10"
        [enableBrowserTooltips]="true"
        [components]="components"
        [rowClassRules]="rowClassRules"
        [getRowStyle]="getRowStyle"
        (gridReady)="onGridReady($event)">
      </ag-grid-angular>

    </div>

  </div>

</div>
